// FROZEN snapshot of the checklist item lists as they stood before the form was
// rebuilt from the 2026 "AMBULANCE CHECKLIST" Excel sheet (commit bd13852).
//
// Nothing here is used by the live form — it exists so checklists SUBMITTED
// against this revision keep rendering, printing and exporting exactly as they
// did when they were signed. A controlled medical record must not change shape
// under the people who signed it. Never edit these lists; a future revision
// gets its own frozen file.
// Vehicle & Mechanical Readiness — mark + remarks per item.
export const VEHICLE_MECHANICAL_V1 = [
    ["exteriorBodyClean", "Exterior body clean"],
    ["cabinDisinfected", "Cabin disinfected"],
    ["fuelLevel", "Fuel level > 3/4"],
    ["oilLevel", "Oil level checked"],
    ["radiatorWater", "Radiator water checked"],
    ["batteryTerminals", "Battery terminals secure"],
    ["tiresCondition", "Tires condition and pressure"],
    ["brakes", "Brakes functional"],
    ["headlightsIndicators", "Headlights / indicators"],
    ["siren", "Siren operational"],
    ["driverAC", "Driver A/C functional"],
    ["windshieldWipers", "Windshield wipers"],
    ["mirrors", "Mirrors intact"],
    ["fireExtinguisherValid", "2 Fire extinguisher valid"],
    ["spareTire", "Spare tire available"],
    ["ambulanceTools", "Ambulance tools available"],
    ["mileageRecorded", "Vehicle mileage recorded"],
    ["medicalWasteDisposed", "Medical waste disposed properly"],
    ["dailyClean", "Daily clean inside / outside"],
    ["cabinetLights", "Cabinet lights functional"],
];
// Medical & Equipment Readiness — qty + mark + remarks per item.
export const MEDICAL_EQUIPMENT_V1 = [
    ["radio", "Radio", "1"],
    ["laptopCad", "Tablet - CAD system functional", "1"],
    ["mainOxygen", "Main oxygen > 700 PSI", "1"],
    ["portableOxygen", "Portable oxygen > 1000 PSI", "1"],
    ["flowmeter", "Flowmeter", "1"],
    ["oxygenRegulator", "Oxygen regulator operational", "1"],
    ["refrigerator", "Refrigerator clean & temperature logged", "1"],
    ["blanket", "Blanket", "1"],
    ["bedSheet", "Bed sheet", "1"],
    ["portableSuction", "Portable suction", "1"],
    ["stretcherStraps", "Stretcher with straps", "1"],
    ["extraStrykerBattery", "Extra Stryker battery charged", "1"],
    ["stairChair", "Stair chair with straps", "1"],
    ["foldingStretcher", "Folding stretcher available", "1"],
    ["scoopStretcher", "Scoop stretcher", "1"],
    ["defibrillator", "Defibrillator operational", "1"],
    ["stethoscope", "Stethoscope", "1"],
    ["glucometer", "Glucometer with strips & lancet", "1"],
    ["thermometer", "Thermometer working", "1"],
    ["emergencyBag", "ACLS Bag", "1"],
];
// ACLS Bag — qty + mark + nearest expiry date per item (plus a seal number).
export const ACLS_ITEMS_V1 = [
    ["medicationBagSealed", "Medication bag available and sealed", "1"],
    ["opa", "OPA (00, 1, 2, 3, 4)", "1"],
    ["npa", "NPA (7, 8)", "1"],
    ["bvm", "BVM (Adult & Neonate)", "1"],
    ["ivCannula", "IV Cannula (14, 18, 20, 22, 24, 26)", "1"],
    ["tegadermPlasterTourniquet", "Tegaderm & Plaster & Tourniquet", "1"],
    ["gauze4x4", "Gauze 4×4", "2 Box"],
    ["paraffinGauze10", "Paraffin gauze 10×10", "4"],
    ["paraffinGauze5", "Paraffin gauze 5×5", "4"],
    ["crepeBandage", "Crepe bandage 10cm × 4.5m", "2"],
    ["conformingBandage", "Conforming bandage", "2"],
    ["cannulaSet", "Cannula set", "2"],
    ["nasalMaskAdult", "Nasal mask (Adult)", "2"],
    ["nasalMaskPedia", "Nasal mask (Pedia)", "2"],
    ["simpleMaskPedia", "Simple mask (Pedia)", "2"],
    ["simpleMaskAdult", "Simple mask (Adult)", "2"],
    ["nrmAdult", "NRM (Adult)", "2"],
    ["nrmPedia", "NRM (Pedia)", "2"],
    ["eyePads", "Eye pads", "3"],
    ["razor", "Razor", "1"],
    ["syringes", "Syringes (1, 3, 5, 10, 20, 50 mL)", "1"],
    ["plaster", "Plaster", "1"],
    ["tourniquet", "Tourniquet", "1"],
    ["alcoholSwab", "Alcohol swab", "1 Box"],
    ["lma", "LMA (1, 2, 3, 4, 5)", "1"],
    ["icePack", "Ice pack", "2"],
    ["flushSalineSyringe", "Flush saline syringe", "3"],
    ["cCollar", "C-Collar", "1"],
    ["triangularBandage", "Triangular bandage", "1"],
];
// Compartments — qty + mark + nearest expiry date per item.
export const COMP_AIRWAY_V1 = [
    ["opaNpa", "OPA / NPA", "1"],
    ["bvm", "BVM (Adult, Pedia, Neonate)", "1"],
    ["lma", "LMA (sizes 1–5)", "1"],
    ["magillForceps", "Magill forceps", "1"],
    ["yankauerSuction", "Yankauer & suction tubing", "2"],
    ["suctionTubes", "Soft (size 8–12) & rigid suction tubes", "2"],
];
export const COMP_BREATHING_V1 = [
    ["nasalCannula", "Nasal cannula (Adult & Pedia)", "2"],
    ["simpleMask", "Simple mask (Adult & Pedia)", "2"],
    ["nonrebreatherMask", "Nonrebreather mask (Adult & Pedia)", "2"],
    ["nebulizerKit", "Nebulizer kit with mask (Adult & Pedia)", "2"],
];
export const COMP_CIRCULATION_V1 = [
    ["ivCannula", "IV cannula (18, 20, 22, 24)", "2"],
    ["ivInfusionSets", "IV infusion sets & 3-way stopcock", "5"],
    ["syringes", "Syringes (1–50 mL)", "3"],
    ["tegadermPlasterTourniquet", "Tegaderm / plaster / tourniquet", "10"],
    ["pressureIvBag", "Pressure IV bag", "1"],
    ["alcoholSwabs", "Alcohol swabs", "1"],
    ["glucometer", "Glucometer & strips & lancets", "1"],
];
export const COMP_INFECTION_V1 = [
    ["disposableGloves", "Disposable gloves (S, M, L, XL)", "1"],
    ["n95SurgicalMasks", "N95 / surgical masks", "1"],
    ["faceShieldGoggles", "Face shield / goggles", "5"],
    ["gowns", "Gowns (yellow / surgical)", "1"],
    ["headShoeCover", "Head & shoe cover", "1"],
    ["handSanitizer", "Hand sanitizer bottles", "1"],
    ["sanitizerWipes", "Sanitizer wipes box", "1"],
    ["biohazardBags", "Biohazard bags", "3"],
    ["bloodSpillKit", "Blood spill kit", "1"],
    ["garbageEmptied", "Garbage emptied / clean", "#"],
];
export const COMP_IMMOBILIZATION_V1 = [
    ["cCollar", "C-collar (Adult / Pedia)", "2"],
    ["backboard", "Backboard with straps", "1"],
    ["headImmobilizer", "Head immobilizer", "1"],
    ["samSplints", "SAM / rigid splints", "2"],
    ["triangularBandage", "Triangular bandage", "2"],
    ["crepeBandage", "Crepe bandage", "3"],
    ["eyeShield", "Eye shield", "3"],
    ["burnPad", "Burn pad", "5"],
    ["burnSheet", "Burn sheet", "2"],
    ["multiTraumaDressing", "Multi-trauma dressing", "5"],
    ["underPads", "Under pads / chux", "10"],
    ["bandageScissors", "Bandage scissors", "1"],
];
export const COMP_OB_V1 = [
    ["obKit", "OB kit complete", "1"],
    ["icePack", "Ice pack", "10"],
];
// Items inside an "expiry" section that do NOT carry a nearest expiry date
// (they show no date field on the form, and "—" in the expiry column on print).
export const NO_EXPIRY_ITEMS_V1 = new Set([
    "backboard",
    "headImmobilizer",
    "biohazardBags",
    "garbageEmptied",
]);
// One entry per new section: the data field holding the marks, the field
// holding the per-item extra (remarks or expiry date), and its kind.
export const NEW_CHECKLIST_SECTIONS_V1 = [
    {
        key: "vehicleMechanical",
        extraKey: "vehicleMechanicalRemarks",
        extra: "remarks",
        label: "Vehicle & Mechanical Readiness",
        items: VEHICLE_MECHANICAL_V1,
    },
    {
        key: "medicalEquipment",
        extraKey: "medicalEquipmentRemarks",
        extra: "remarks",
        label: "Medical & Equipment Readiness",
        items: MEDICAL_EQUIPMENT_V1,
    },
    {
        key: "aclsItems",
        extraKey: "aclsExpiry",
        extra: "expiry",
        label: "ACLS Bag",
        items: ACLS_ITEMS_V1,
    },
    {
        key: "compAirway",
        extraKey: "compAirwayExpiry",
        extra: "expiry",
        label: "Compartment A – Airway",
        items: COMP_AIRWAY_V1,
    },
    {
        key: "compBreathing",
        extraKey: "compBreathingExpiry",
        extra: "expiry",
        label: "Compartment B – Breathing",
        items: COMP_BREATHING_V1,
    },
    {
        key: "compCirculation",
        extraKey: "compCirculationExpiry",
        extra: "expiry",
        label: "Compartment C – Circulation",
        items: COMP_CIRCULATION_V1,
    },
    {
        key: "compImmobilization",
        extraKey: "compImmobilizationExpiry",
        extra: "expiry",
        label: "Compartment D – Disability",
        items: COMP_IMMOBILIZATION_V1,
    },
    {
        key: "compOb",
        extraKey: "compObExpiry",
        extra: "expiry",
        label: "Compartment E – OB & Emergency Kit",
        items: COMP_OB_V1,
    },
    {
        key: "compInfection",
        extraKey: "compInfectionExpiry",
        extra: "expiry",
        label: "Compartment F – Infection Control & PPE",
        items: COMP_INFECTION_V1,
    },
];
// ——— Which revision does a stored checklist belong to? ———
//
// Submissions carry no version field, so the revision is read off the data:
// every item must be marked before a checklist can be submitted, so a v1
// document always contains v1-only item keys in these records. Each marker
// below is a key that exists in v1 and in NO later revision.
const V1_MARKERS = [
    ["medicalEquipment", "stairChair"],
    ["compAirway", "opaNpa"],
    ["compImmobilization", "backboard"],
    ["compInfection", "garbageEmptied"],
    ["aclsItems", "opa"],
];
/**
 * True when this checklist was submitted against the pre-2026 revision, and so
 * must be rendered with the frozen lists above rather than the current form.
 */
export function isV1Checklist(d) {
    if (!d || typeof d !== "object")
        return false;
    const doc = d;
    return V1_MARKERS.some(([section, key]) => {
        const rec = doc[section];
        return !!rec && typeof rec === "object" && key in rec;
    });
}
//# sourceMappingURL=checklistFieldsV1.js.map